module.exports = __webpack_public_path__ + "media/images/DigitalJournal-black-5f63361ec4bc768bf67589414c0583d2.png";